import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { CsvUploader, WRITE_OFFS_CATEGORY } from '../../csv-uploader';

export const BILLING_CSV_UPLOAD_TEST_ID = 'billing-csv-upload-section';

export const BILLING_UPLOAD_CATEGORIES = [WRITE_OFFS_CATEGORY];

const BillingCsvUpload = (): JSX.Element => (
  <HHStack
    direction="column"
    spacing={4}
    padding={4}
    data-testid={BILLING_CSV_UPLOAD_TEST_ID}
  >
    <HHTypography hhVariant="section-title">CSV Upload</HHTypography>
    <CsvUploader allowedCategories={BILLING_UPLOAD_CATEGORIES} />
  </HHStack>
);

export default BillingCsvUpload;
